import { ListInvoiceItem } from 'generated/api-client';
import React, { FunctionComponent } from 'react';
import { Label } from 'semantic-ui-react';

type Props = {
  status: ListInvoiceItem['status'];
};

// Where the invoice stands with its payment in Pennylane, in the colors of
// the Zoho invoices
export const InvoiceStatusLabel: FunctionComponent<Props> = ({ status }) => {
  switch (status) {
    case 'upcoming':
      return <Label color="blue">À venir</Label>;
    case 'late':
      return <Label color="orange">En retard</Label>;
    case 'partially-paid':
      return <Label color="yellow">Partiellement payée</Label>;
    case 'paid':
      return <Label color="green">Payée</Label>;
    case 'partially-cancelled':
      return (
        <Label color="grey" basic>
          Partiellement annulée
        </Label>
      );
    case 'cancelled':
      return <Label color="grey">Annulée</Label>;
  }
};
